"use strict";

var forEach = Array.prototype.forEach, create = Object.create;

// eslint-disable-next-line no-unused-vars
module.exports = function (arg /*, …args*/) {
	var set = create(null);
	forEach.call(arguments, function (name) {
		set[name] = true;
	});
	return set;
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/primitive-set.js
// module id = 830
// module chunks = 0